var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3 row"},[_c('label',{staticClass:"col-md-2 col-form-label"},[_vm._v("Aluno")]),_c('div',{staticClass:"col-md-10"},[_c('input',{staticClass:"form-control",attrs:{"readonly":""},domProps:{"value":_vm.aluno.nome}})])])}
var staticRenderFns = []

export { render, staticRenderFns }